import { alpha, Box, Stack, Theme, useTheme } from "@mui/material";
import FormUpdateVisitor from "components/Check-in/FormUpdateVisitor/FormUpdateVisitor";
import CheckInQrCode from "components/CheckInQrCode";
import { ROUTES } from "helpers/routes";

const UpdateMyInfo = () => {
  const theme: Theme = useTheme();

  return (
    <Box
      width="100%"
      maxWidth={1000}
      margin="0 auto"
      borderRadius={3}
      overflow="hidden"
      marginTop={6}
      bgcolor={alpha(theme.palette.common.black, 0.3)}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        style={{ width: "100%" }}
      >
        <Box flex="1 1 auto" bgcolor={theme.palette.common.white} padding={4}>
          <FormUpdateVisitor />
        </Box>
        <Box display={{ xs: "none", md: "flex" }}>
          <CheckInQrCode
            value={ROUTES.UPDATE_MY_INFO}
            message="You can also use your phone to update your information"
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default UpdateMyInfo;
